module.exports = __webpack_public_path__ + "static/img/media-data1.62eb3aed.svg";